/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import type { DiagramContextMenuContext, PromotedLinkId } from '../diagram.types';

export function getDiagramContextMenuContext<K1, K2, D1, D2>(
  nodesMap: Map<K1, D1>,
  linksMap: Map<K2, D2>,
  type: 'node' | 'link' | 'promotedLink' | 'background',
  idx?: K1 | K2 | PromotedLinkId<K1, D2> | string
) {
  let context: DiagramContextMenuContext<K1, D1, D2>;

  if (type === 'node') {
    context = {
      data: nodesMap.get(idx as K1)!,
      type
    };
  } else if (type === 'link') {
    context = {
      data: linksMap.get(idx as K2)!,
      type
    };
  } else if (type === 'promotedLink') {
    context = {
      id: idx as PromotedLinkId<K1, D2>,
      type
    };
  } else {
    context = {
      type: 'background'
    };
  }

  return {
    context: context as DiagramContextMenuContext<K1, D1, D2>
  };
}
